import { createContext } from 'react';
import type { SupportedLocale, TranslationKey, TranslationValues, TranslationDictionary } from './utils';

// Custom type for ListFormat options (kept here for context consumers)
export interface ListFormatOptions {
  style?: 'long' | 'short' | 'narrow';
  type?: 'conjunction' | 'disjunction' | 'unit';
  localeMatcher?: 'lookup' | 'best fit';
}

export interface I18nContextType {
  locale: SupportedLocale;
  setLocale: (locale: SupportedLocale) => Promise<void>;
  t: (key: TranslationKey, values?: TranslationValues) => string;
  formatNumber: (value: number, options?: Intl.NumberFormatOptions) => string;
  formatCurrency: (value: number, currency?: string) => string;
  formatDate: (date: Date | string, options?: Intl.DateTimeFormatOptions) => string;
  formatRelativeTime: (date: Date | string) => string;
  formatList: (items: string[], options?: ListFormatOptions) => string;
  isRTL: boolean;
  direction: 'ltr' | 'rtl';
  isLoading: boolean;
}

export const I18nContext = createContext<I18nContextType | undefined>(undefined);

export default {};
